import i18n from "i18next";
import { ERROR_EMPLOYEE_CLASSIFICATIONS, GET_EMPLOYEE_CLASSIFICATIONS, UNATORIZED } from "./types";

const EmployeeClassificationReducer = (state, action) => {
    const { payload, type } = action;
    switch (type) {
        case GET_EMPLOYEE_CLASSIFICATIONS:
            return {
                ...state,
                employeeClassifications: payload,
                isFetching: false,
                error: false,
                message: '',
                tokenError: false
            }
        case ERROR_EMPLOYEE_CLASSIFICATIONS:
            return {
                ...state,
                isFetching: false,
                error: true,
                message: i18n.t('common.error_server'),
            }
        case UNATORIZED:
            return {
                ...state,
                isFetching: false,
                error: true,
                message: i18n.t('common.error_token'),
                tokenError: true
            }
        default:
            return state
    }
}

export default EmployeeClassificationReducer